import styled, { css } from 'styled-components';

import { mixins } from '../../styles/breakpoints';
import colors from '../../styles/colors';

import Card from '../Card';

const OnboardingCard = styled(Card)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  flex: 1;
  gap: 70px;
  overflow: visible;
  min-height: fit-content;
  margin-top: 45px;
  margin-bottom: 20px;
  box-shadow: none;
  width: 100%;

  ${mixins.tabletMedia(css`
    max-width: 400px; 
  `)}

  ${mixins.upToDesktopMedia(css`
    gap: 40px;
  `)}

  background-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark1 : colors.base.alpha)};
  ${(props) => props.modal && 'z-index: 2;'};
`;

export default OnboardingCard;
